import { render, staticRenderFns } from "./CouponText.vue?vue&type=template&id=3fc64880&scoped=true&lang=pug"
import script from "./CouponText.vue?vue&type=script&lang=js"
export * from "./CouponText.vue?vue&type=script&lang=js"
import style0 from "./CouponText.vue?vue&type=style&index=0&id=3fc64880&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.96.1__lodash@4.17.21__lkjqg4lemhx3tcnq4xpodjyioi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc64880",
  null
  
)

export default component.exports